import styled from 'styled-components';
import { colors, breakpoints } from 'nicollet-tokens';
import { ndsFontReset } from '@nicollet/common';

const topDivider = `border-top: 1px solid ${colors.palette.gray.light}`;
const bottomDivider = `border-bottom: 1px solid ${colors.palette.gray.light}`;
const topBottomDivider = `
border-top: 1px solid ${colors.palette.gray.light};
border-bottom: 1px solid ${colors.palette.gray.light};
`;
const topOnlySmallScreenDivider = `
  @media (max-width: ${breakpoints.xsMax}) {
    border-top: 1px solid ${colors.palette.gray.light};
  }
`;
/**
 * This divider is only for Cells that have a valid renderLeading prop.
 * This style creates a bottom border that begins after the renderLeading element.
 *
 * A faux border is created with a pseudo-element off the second element:
 * > *:nth-child(2)::before { ...
 *
 * The transparent border it has a consistent 1px height increase like the others.
 */

const bottomExcludeLeading = `
  position: relative;
  border-bottom: 1px solid transparent;
  overflow: hidden;
  > *:nth-child(2)::before {
    content: '';
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 1px;
    border-bottom: 1px solid ${colors.palette.gray.light};
  }
`;
const BaseCellWrapper = styled.div`
  ${ndsFontReset()};
  display: flex;
  background-color: white;
  ${({
  divider
}) => divider === 'top' && topDivider}
  ${({
  divider
}) => divider === 'bottom' && bottomDivider}
  ${({
  divider
}) => divider === 'topBottom' && topBottomDivider}
  ${({
  divider
}) => divider === 'topOnlySmallScreen' && topOnlySmallScreenDivider}
  ${({
  divider
}) => divider === 'bottomExcludeLeading' && bottomExcludeLeading}
`;

export { BaseCellWrapper, bottomDivider, bottomExcludeLeading, topBottomDivider, topDivider, topOnlySmallScreenDivider };
